import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import SocialMediaBar from "../components/SocialMediaBar";
import { customColour } from "../data/colour";
import { whiteLogo, isTabWidth } from "../data/database";

const Footer = () => {
  const isTab = useMediaQuery(isTabWidth);

  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: `${isTab ? "0" : "5rem"}`,
        paddingBottom: `${isTab ? "2.5rem" : "5rem"}`,
        display: "grid",
        gridTemplateRows: `${isTab ? "1fr 3fr" : "repeat(1, 1fr)"}`,
        backgroundColor: customColour.darkerBlue,
        color: customColour.white,
      }}
    >
      <Box sx={{ width: `${isTab ? "90%" : "20%"}`, margin: "auto" }}>
        <SocialMediaBar />
      </Box>
      <Box
        sx={{
          display: "grid",
          width: "auto",
          gridTemplateColumns: `${isTab ? "repeat(1, 1fr)" : "repeat(3, 1fr)"}`,
          gridTemplateRows: `${isTab ? "repeat(3, 1fr)" : "repeat(1, 1fr)"}`,
        }}
      >
        <Box
          sx={{
            marginLeft: `${isTab ? "0" : "5rem"}`,
            textAlign: `${isTab ? "center" : "left"}`,
            fontSize: "1rem",
            fontWeight: "600",
          }}
        >
          <p>6334 Group</p>
          <Box
            sx={{
              fontSize: "0.75rem",
              fontWeight: "100",
            }}
          >
            <p>
              867, Durosimi Abokunwa Street,
              <br />
              Omole Phase II, Lagos, Nigeria.
              <br />
              +234 802 318 7712 | fisayo@6334group.net
              <br />
              &copy; 2020 - 2025
            </p>
          </Box>
        </Box>
        <Box sx={{ display: "grid", placeItems: "center" }}>
          <img src={whiteLogo} alt="white_logo" width="80px" />
        </Box>
        <Box
          sx={{
            marginRight: `${isTab ? "0" : "5rem"}`,
            fontSize: "1rem",
            fontWeight: "600",
            textAlign: `${isTab ? "center" : "end"}`,
          }}
        >
          <p>Useful Links</p>
          <Box
            sx={{
              fontSize: "0.75rem",
              fontWeight: "100",
              lineHeight: "0.75rem",
              display: "flex",
              flexDirection: "column",
              textDecoration: "none",
              "& a": {
                color: customColour.white, // Initial color of the links
                textDecoration: "none", // No underline
                transition: "color 0.3s, text-shadow 0.3s", // Smooth transition for hover effects
              },
              "& a:hover": {
                color: customColour.lightBlue, // Hover color
                textShadow: "0px 0px 20px rgba(55, 166, 222, 0.8)",
                filter: "brightness(1.2)",
              },
            }}
          >
            <a href="/about">About Us</a>
            <a href="/services">Services</a>
            <a href="contact#faqs">FAQs</a>
            <a href="contact#consult">Schedule a Consultation</a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
